var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import './style/index.scss';
/**
 * @author tongxiaokang
 * @version 0.0.1
 */
export default class ButtonGroup extends React.PureComponent {
    render() {
        const _a = this.props, { prefixCls, className, children, theme, size, inline, radius } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children", "theme", "size", "inline", "radius"]);
        const child = children.map((child, index) => {
            const props = { theme, size, inline, radius, key: index };
            const length = children.length;
            if (length > 1) {
                if (index === 0) {
                    props.className = cls(child.props.className, `${prefixCls}-first-child`);
                }
                else if (index === length - 1) {
                    props.className = cls(child.props.className, `${prefixCls}-last-child`);
                }
                else {
                    props.className = cls(child.props.className, `${prefixCls}-child`);
                }
            }
            return React.cloneElement(child, props);
        });
        return (<div className={cls(prefixCls, className, {
            [`${prefixCls}-inline`]: inline,
            [`${prefixCls}-block`]: !inline,
            [`${prefixCls}-radius`]: radius,
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-theme`]: theme
        })} {...resetProps}>{child}</div>);
    }
}
ButtonGroup.defaultProps = {
    prefixCls: 'x-button-group',
    inline: true
};
